import React from "react";

function Contact() {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.6004 11.9999C21.6004 14.546 20.589 16.9878 18.7886 18.7881C16.9883 20.5885 14.5465 21.5999 12.0004 21.5999C9.45431 21.5999 7.01252 20.5885 5.21217 18.7881C3.41182 16.9878 2.40039 14.546 2.40039 11.9999C2.40039 9.45382 3.41182 7.01203 5.21217 5.21168C7.01252 3.41133 9.45431 2.3999 12.0004 2.3999C14.5465 2.3999 16.9883 3.41133 18.7886 5.21168C20.589 7.01203 21.6004 9.45382 21.6004 11.9999ZM19.2004 11.9999C19.2004 13.1915 18.9112 14.3147 18.3988 15.3047L16.57 13.4747C16.8438 12.6271 16.8762 11.7201 16.6636 10.8551L18.538 8.9807C18.9628 9.8987 19.2004 10.9199 19.2004 11.9999ZM13.0024 16.6955L14.8984 18.5915C13.9852 18.9936 12.9982 19.2008 12.0004 19.1999C10.9578 19.2012 9.92747 18.9752 8.98119 18.5375L10.8556 16.6631C11.5596 16.8356 12.2935 16.8467 13.0024 16.6955ZM7.38999 13.3403C7.15384 12.5272 7.13687 11.6661 7.34079 10.8443L7.24479 10.9403L5.40879 9.1007C5.00656 10.0143 4.79934 11.0017 4.80039 11.9999C4.80039 13.1447 5.06799 14.2271 5.54319 15.1883L7.39119 13.3403H7.38999ZM8.69559 5.6003C9.71706 5.07232 10.8505 4.7978 12.0004 4.7999C13.1452 4.7999 14.2276 5.0675 15.1888 5.5427L13.3408 7.3907C12.4195 7.12235 11.439 7.13615 10.5256 7.4303L8.69559 5.6015V5.6003ZM14.4004 11.9999C14.4004 12.6364 14.1475 13.2469 13.6974 13.697C13.2474 14.147 12.6369 14.3999 12.0004 14.3999C11.3639 14.3999 10.7534 14.147 10.3033 13.697C9.85325 13.2469 9.60039 12.6364 9.60039 11.9999C9.60039 11.3634 9.85325 10.7529 10.3033 10.3028C10.7534 9.85276 11.3639 9.5999 12.0004 9.5999C12.6369 9.5999 13.2474 9.85276 13.6974 10.3028C14.1475 10.7529 14.4004 11.3634 14.4004 11.9999Z"
          fill="#111827"
        />
      </svg>
    </span>
  );
}

export default Contact;
